export default __webpack_public_path__ + "locales/pl/Common.json?hash=4701311c518dc3b4eb5e1706473233e3";